import { AvInput, AvGroup, AvFeedback } from 'availity-reactstrap-validation'
import { Label } from 'reactstrap'

export default ({ name, placeholder, type = 'text', required = false, label, error, validate = {}, id }) => (
  <AvGroup className="group">
    <AvInput
      className="form-input"
      name={name}
      id={id || name}
      placeholder={placeholder}
      type={type}
      required={required}
      validate={validate}
    />
    <span className="highlight"></span> <span className="bar"></span>
    <Label for={id || name}>{required && '*'} {label}</Label>
    <AvFeedback className="form-input-error">{error}</AvFeedback>
  </AvGroup>
)



// WEBPACK FOOTER //
// src/components/AvCustomInput.js